import * as React from 'react';
import { ModalWindow } from '@cian/ui-kit';

import { Agreement, Link, Text } from '../../components/Agreement';
import { useModalWindow } from '../../utils/useModalWindow';
import { TAgreementTemplate } from '../../types';
import { EAgreementPartsTypes } from '../../constants';

export interface IAgreementContainerProps {
  /** Шаблон соглашения **/
  template: TAgreementTemplate[];
  /** Каждый элемент отдельной строкой**/
  multiLine?: boolean;

  /** Вызов колбека - если потребуется отслеживать клики на ссылки, например для событий **/
  onClickLink?(name: string): void;
}
export const AgreementContainer: React.FC<IAgreementContainerProps> = props => {
  const { onClickLink = Function.prototype, template, multiLine } = props;
  const { openModal, modalProps } = useModalWindow();

  const text = React.useMemo(
    () =>
      template.map((agreement, index) => {
        switch (agreement.type) {
          case EAgreementPartsTypes.Link:
            return (
              <Link
                key={index}
                text={agreement.text}
                href={agreement.href}
                multiLine={multiLine}
                onClick={() => onClickLink(agreement.name)}
              />
            );
          case EAgreementPartsTypes.Modal:
            return (
              <Link
                key={index}
                text={agreement.text}
                multiLine={multiLine}
                onClick={() => {
                  openModal({ content: <Text text={agreement.content} />, title: agreement.title });
                  onClickLink(agreement.name);
                }}
              />
            );
          default:
            return <Text key={index} text={agreement.text} multiLine={multiLine} />;
        }
      }),
    [template, onClickLink, openModal, multiLine],
  );

  return (
    <>
      <Agreement multiLine={multiLine}>{text}</Agreement>
      <ModalWindow {...modalProps} />
    </>
  );
};

AgreementContainer.displayName = 'AgreementContainer';
